import React, {useEffect, useState, useContext} from 'react'
import DivLayout from 'components/sales/divLayout/divLayout';
import Layout from 'components/sales/layout/layout';
import localization from "../../../assets/localization/localization";
import { Button } from 'react-bootstrap';
import CustomModal from "../../valetServices/modal";
import ModalPop from 'components/sales/modal/modal';
import ConstantInput from 'components/sales/Input/constantInput/constantInput';
import {toast} from "react-toastify";
import DocumentView from 'components/sales/downloadDocView/documentView';
import Images from 'assets/images/imageData';
import { BaseUrl } from "contexts/baseUrl/baseUrl";

const MrfFinanceView = ({
    match,
    mrfViewShown,
    showMrfView = []
}) => {

    const [isLoading, setIsLoading] = useState(false);

    useEffect(() => {
        (async () => {
            setIsLoading(true);
            await mrfViewShown(match?.params?.mrf_id)
            setIsLoading(false);
        })()
    }, [])

    return (
        <Layout
            title={localization.BacktoList}
            isGoback
            isLoading={isLoading}
        >
            {showMrfView
                ?
                <>
                    <div className="panel-card card-details" width="100%">
                        <div className="panel-heading">{'Show Material Requisition Form (MRF)'}</div>
                        <div className="panel-body">
                            <div className="details-listing detail_alignment">
                                <DivLayout
                                    heading={"MRF No."}
                                    data={
                                        showMrfView?.materialRequisition?.id
                                    }
                                />
                                <DivLayout
                                    heading={'Site No.'}
                                    data={
                                        showMrfView?.materialRequisition?.site_no
                                    }
                                />
                                <DivLayout
                                    heading={'Site Type'}
                                    data={
                                        showMrfView?.materialRequisition?.site_type
                                    }
                                />

                                <DivLayout
                                    heading={'Site Name'}
                                    data={
                                        showMrfView?.materialRequisition?.client_name
                                    }
                                />

                                <DivLayout
                                    heading={'Planned Delivery Date'}
                                    data={
                                        showMrfView?.materialRequisition?.planned_delivery_date
                                    }
                                />

                                <DivLayout
                                    heading={'Remarks'}
                                    data={
                                        showMrfView?.materialRequisition?.remarks
                                    }
                                />

                                <DivLayout
                                    heading={'Type'}
                                    data={
                                        showMrfView?.materialRequisition?.type
                                    }
                                />

                                <DivLayout
                                    heading={'Status'}
                                    data={
                                        showMrfView?.materialRequisition?.status
                                    }
                                />

                                <DivLayout
                                    heading={'Scope'}
                                    data={
                                        showMrfView?.materialRequisition?.scope
                                    }
                                />

                                <DivLayout
                                    heading={'Created By'}
                                    data={
                                        showMrfView?.materialRequisition?.created_by
                                    }
                                />

                                <DivLayout
                                    heading={'Created At'}
                                    data={
                                        showMrfView?.materialRequisition?.created_at
                                    }
                                />
                            </div>
                        </div>
                    </div>

                    <div className="panel-card card-details" width="100%">
                        <div className="panel-heading">{'Material Requisition Form (Billing Address)'}</div>
                        <div className="panel-body">
                            <div className="details-listing detail_alignment">
                                {showMrfView?.address && showMrfView?.address[0] && showMrfView?.address[0]?.details && (
                                    <DivLayout
                                        heading={"Contact Name"}
                                        data={
                                            JSON.parse(showMrfView?.address[0]?.details)['contact_name']
                                        }
                                    />
                                )}

                                { showMrfView?.address && showMrfView?.address[0] && showMrfView?.address[0]?.details && (
                                    <DivLayout
                                        heading={'Contact Number'}
                                        data={
                                            JSON.parse(showMrfView?.address[0]?.details)['contact_number']
                                        }
                                    />
                                )}
                                
                                { showMrfView?.address && showMrfView?.address[0] && showMrfView?.address[0]?.details && (
                                    <DivLayout
                                        heading={'Email'}
                                        data={
                                            JSON.parse(showMrfView?.address[0]?.details)['contact_email']
                                        }
                                    />
                                )}

                            { showMrfView?.address && showMrfView?.address[0] && showMrfView?.address[0]?.details && (
                                <DivLayout
                                    heading={'State'}
                                    data={
                                        JSON.parse(showMrfView?.address[0]?.details)['state']
                                    }
                                />
                            )}
                            { showMrfView?.address && showMrfView?.address[0] && showMrfView?.address[0]?.details && (
                                <DivLayout
                                    heading={'City'}
                                    data={
                                        JSON.parse(showMrfView?.address[0]?.details)['city']
                                    }
                                />
                            )}
                            { showMrfView?.address && showMrfView?.address[0] && showMrfView?.address[0]?.details && (
                                <DivLayout
                                    heading={'Pincode'}
                                    data={
                                        JSON.parse(showMrfView?.address[0]?.details)['pincode']
                                    }
                                />
                            )}
                            { showMrfView?.address && showMrfView?.address[0] && showMrfView?.address[0]?.details && (
                                <DivLayout
                                    heading={'Address'}
                                    data={
                                        JSON.parse(showMrfView?.address[0]?.details)['address']
                                    }
                                />
                            )}
                            </div>
                        </div>
                    </div>

                {showMrfView?.address && showMrfView?.address[1] && (
                    <div className="panel-card card-details" width="100%">
                    <div className="panel-heading">{'Material Requisition Form (Shipping Address)'}</div>
                    <div className="panel-body">
                        <div className="details-listing detail_alignment">
                            {showMrfView?.address && showMrfView?.address[1] && showMrfView?.address[1]?.details && (
                                <DivLayout
                                    heading={"Contact Name"}
                                    data={
                                        JSON.parse(showMrfView?.address[1]?.details)['contact_name']
                                    }
                                />
                            )}

                            { showMrfView?.address && showMrfView?.address[1] && showMrfView?.address[1]?.details && (
                                <DivLayout
                                    heading={'Contact Number'}
                                    data={
                                        JSON.parse(showMrfView?.address[1]?.details)['contact_number']
                                    }
                                />
                            )}
                            
                            { showMrfView?.address && showMrfView?.address[1] && showMrfView?.address[1]?.details && (
                                <DivLayout
                                    heading={'Email'}
                                    data={
                                        JSON.parse(showMrfView?.address[1]?.details)['contact_email']
                                    }
                                />
                            )}

                        { showMrfView?.address && showMrfView?.address[1] && showMrfView?.address[1]?.details && (
                            <DivLayout
                                heading={'State'}
                                data={
                                    JSON.parse(showMrfView?.address[1]?.details)['state']
                                }
                            />
                        )}
                        { showMrfView?.address && showMrfView?.address[1] && showMrfView?.address[1]?.details && (
                            <DivLayout
                                heading={'City'}
                                data={
                                    JSON.parse(showMrfView?.address[1]?.details)['city']
                                }
                            />
                        )}
                        { showMrfView?.address && showMrfView?.address[1] && showMrfView?.address[1]?.details && (
                            <DivLayout
                                heading={'Pincode'}
                                data={
                                    JSON.parse(showMrfView?.address[1]?.details)['pincode']
                                }
                            />
                        )}
                        { showMrfView?.address && showMrfView?.address[1] && showMrfView?.address[1]?.details && (
                            <DivLayout
                                heading={'Address'}
                                data={
                                    JSON.parse(showMrfView?.address[1]?.details)['address']
                                }
                            />
                        )}
                        </div>
                    </div>
                </div>
                )}
                    

                  {showMrfView && showMrfView?.lineItem && (
                    <div className="panel-card card-details">
                        <div className="panel-heading">{'Material Requisition Form Line Items'}</div>
                        <div className="panel-body">
                            <div className="details-listing detail_alignment">
                                <table className="table table-striped">
                                    <thead>
                                    <tr>
                                        <th>S.No.</th>
                                        <th>Material Name</th>
                                        <th>Brand</th>
                                        <th>Specification</th>
                                        <th>Group</th>
                                        <th>Material Code</th>
                                        <th>Sale Value</th>
                                        <th>GST(%)</th>
                                        <th>UOM</th>
                                        <th>HSN</th>
                                        <th>Quantity</th>
                                        <th>Refundable</th>
                                        <th>Created By</th>
                                        
                                    </tr>
                                    </thead>
                                    <tbody>
                                    {showMrfView?.lineItem?.map((val, index) => {
                                        return (
                                            <>
                                                <tr>
                                                    <td>{index + 1}</td>
                                                    <td>{val?.material_name}</td>
                                                    <th>{val?.brand_name}</th>
                                                    <td>{val?.specification}</td>
                                                    <th>{val?.group}</th>
                                                    <th>{val?.material_code}</th>
                                                    <th>{val?.sale_value}</th>
                                                    <th>{val?.gst}</th>
                                                    <th>{val?.uom}</th>
                                                    <th>{val?.hsn_code}</th>
                                                    <th>{val?.quantity}</th>
                                                    <th>{val?.refundable}</th>
                                                    <th>{val?.created_by}</th>
                                                </tr>
                                            </>
                                        )
                                    })}
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                  )}

                    {showMrfView.materialRequisition && showMrfView.materialRequisition.images && showMrfView.materialRequisition.images[0] && (
                        <div className="panel-card card-details" width="100%">
                            <div className="panel-heading">{'Material Requisition Form Line Items'}</div>
                            <div className="panel-body">
                                <div className="details-listing detail_alignment">
                                    <DocumentView
                                        title={localization.attachment}
                                        attachment={showMrfView?.materialRequisition?.images[0]?.url}
                                    />
                                </div>
                            </div>
                        </div>
                    )}
                </>
                :
                <div>
                    <img src={Images?.NoData} alt="" width="100%" />
                </div>
                }

        </Layout>
    )
}

export default MrfFinanceView